import './Blocks/EventRegistrationButtons/ClosedRegistrationButtonVariation/front.scss';

console.log(`Amplify Events: front module loaded.`)
